class FeaturedBlogSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-featured-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-featured-dot]'));
    this.previousButton = this.querySelector('[data-featured-previous]');
    this.nextButton = this.querySelector('[data-featured-next]');
    this.activeIndex = 0;

    if (this.slides.length === 0) return;

    this.previousButton?.addEventListener('click', this.showPrevious);
    this.nextButton?.addEventListener('click', this.showNext);
    this.dots.forEach((dot) => dot.addEventListener('click', this.selectDot));
    this.addEventListener('keydown', this.handleKeydown);
    this.addEventListener('pointerdown', this.handlePointerDown);
    this.addEventListener('pointerup', this.handlePointerUp);
    this.addEventListener('pointercancel', this.resetPointer);

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    this.showSlide(0);
  }

  disconnectedCallback() {
    this.previousButton?.removeEventListener('click', this.showPrevious);
    this.nextButton?.removeEventListener('click', this.showNext);
    this.dots.forEach((dot) => dot.removeEventListener('click', this.selectDot));
    this.removeEventListener('keydown', this.handleKeydown);
    this.removeEventListener('pointerdown', this.handlePointerDown);
    this.removeEventListener('pointerup', this.handlePointerUp);
    this.removeEventListener('pointercancel', this.resetPointer);
    document.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  showPrevious = () => {
    this.showSlide((this.activeIndex - 1 + this.slides.length) % this.slides.length);
  };

  showNext = () => {
    this.showSlide((this.activeIndex + 1) % this.slides.length);
  };

  selectDot = (event) => {
    this.showSlide(this.dots.indexOf(event.currentTarget));
  };

  handleKeydown = (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    event.preventDefault();
    if (event.key === 'ArrowLeft') {
      this.showPrevious();
    } else {
      this.showNext();
    }
  };

  handleBlockSelect = (event) => {
    const selectedSlide = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
    if (selectedSlide >= 0) this.showSlide(selectedSlide);
  };

  handlePointerDown = (event) => {
    if (event.pointerType === 'mouse') return;
    this.pointerStartX = event.clientX;
  };

  handlePointerUp = (event) => {
    if (this.pointerStartX == null || event.pointerType === 'mouse') return;

    const distance = event.clientX - this.pointerStartX;
    this.resetPointer();

    if (Math.abs(distance) < 50) return;
    if (distance > 0) {
      this.showPrevious();
    } else {
      this.showNext();
    }
  };

  resetPointer = () => {
    this.pointerStartX = null;
  };

  showSlide(index) {
    if (!this.slides[index]) return;

    this.activeIndex = index;

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === index;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

      slide.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
        element.tabIndex = isActive ? 0 : -1;
      });
    });

    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }
}

if (!customElements.get('featured-blog-slider')) {
  customElements.define('featured-blog-slider', FeaturedBlogSlider);
}
